import styles from './NewProgramPreparationStep.module.css';

interface NewProgramPreparationStepProps {
  programUrl: string;
  validationQuestion: string;
  canContinue: boolean;
  onProgramUrlChange: (value: string) => void;
  onValidationQuestionChange: (value: string) => void;
  onContinue: () => void;
  stepCompleted: boolean;
}

export function NewProgramPreparationStep({
  programUrl,
  validationQuestion,
  canContinue,
  onProgramUrlChange,
  onValidationQuestionChange,
  onContinue,
  stepCompleted
}: NewProgramPreparationStepProps) {
  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <div>
          <h3 className={styles.title}>Step 0: Preparation (New Program)</h3>
          <p className={styles.subtitle}>
            Capture the primary source URL for this program and frame the validation question you want the BAM
            workflow to answer. These details anchor the rest of the quality check session.
          </p>
        </div>
        {stepCompleted && <span className={styles.statusBadge}>✓ Completed</span>}
      </div>

      <div className={styles.form}>
        <label className={styles.fieldGroup}>
          <span className={styles.label}>Enter program URL</span>
          <input
            value={programUrl}
            onChange={(event) => onProgramUrlChange(event.target.value)}
            placeholder="https://example-award.org/"
            className={styles.input}
            type="url"
            autoComplete="off"
          />
          <span className={styles.helperText}>
            Paste the most authoritative page for the program (homepage or submissions landing page).
          </span>
        </label>

        <label className={styles.fieldGroup}>
          <span className={styles.label}>Enter validation question</span>
          <textarea
            value={validationQuestion}
            onChange={(event) => onValidationQuestionChange(event.target.value)}
            placeholder="What is the official deadline structure for this program?"
            className={styles.textarea}
          />
          <span className={styles.helperText}>
            Clarify the main outcome you need from this QC session. The question sets expectations for later steps.
          </span>
        </label>
      </div>

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.continueButton}
          onClick={onContinue}
          disabled={!canContinue}
        >
          Continue to Step 1 →
        </button>
        <p className={styles.secondaryText}>
          You can return to this step at any time. The workflow will stay in sync as long as this tab remains open.
        </p>
      </div>
    </section>
  );
}

export default NewProgramPreparationStep;
